import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form } from "antd";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { OrderedMap } from "immutable";
import CompanyService from "services/company-service";
import { INPUT_TYPES } from "constants/input-types";
import { BANK_ACCOUNT_TYPES } from "constants/enums";
import "styles/form.css";

const FORM_FIELDS = new OrderedMap({
    associate: {
        type: INPUT_TYPES.SELECT,
        options: [
            {
                value: "company",
                label: "Company"
            }
        ],
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        label: "A/C Entity",
        className: "form-field fb-33"
    },
    account_type: {
        type: INPUT_TYPES.SELECT,
        options: BANK_ACCOUNT_TYPES.map((value, label) => ({
            value,
            label
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        label: "Account Type",
        className: "form-field fb-33"
    },
    account_holder_name: {
        type: INPUT_TYPES.TEXT,
        options: [],
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
        label: "Account Holder Name",
        className: "form-field fb-33"
    },
    account_number: {
        type: INPUT_TYPES.TEXT,
        label: "Account Number",
        className: "form-field fb-33",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    ifsc_code: {
        type: INPUT_TYPES.OBJECT_SELECT,
        label: "IFSC Code",
        labelProp: "ifsc_code",
        className: "form-field fb-33",
        showSearch: true,
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    bank_branch: {
        type: INPUT_TYPES.OBJECT_TEXT,
        label: "Bank Branch Name",
        className: "form-field fb-33",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    }
});

class AddAssociateBankAccountForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    ifscLookup = str =>
        CompanyService.ifscLookup(str).then(({ data }) => ({
            data: data.results
        }));
    getValueFromObject = bankBranch => {
        if (!bankBranch) {
            return null;
        }
        return bankBranch.name;
    };
    setBankBranchName = branch => {
        this.props.form.setFieldsValue({
            bank_branch: branch
        });
    };
    enhanceFormFields = () =>
        FORM_FIELDS.setIn(["ifsc_code", "onSearch"], this.ifscLookup)
            .setIn(["ifsc_code", "onSelect"], this.setBankBranchName)
            .setIn(
                ["bank_branch", "getValueFromObject"],
                this.getValueFromObject
            )
            .setIn(
                ["associate", "options"],
                [
                    ...this.props.associates
                        .map(_ => _.option)
                        .toList()
                        .toArray(),
                    {
                        value: "company",
                        label: "Company"
                    }
                ]
            );

    render() {
        this.fields = this.enhanceFormFields();
        return (
            <Form className={cx("form", "br-3")}>
                <div className={"form-row"}>
                    {this.fields
                        .map((field, fieldName) =>
                            this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )()
                        )
                        .toList()}
                </div>
            </Form>
        );
    }
}

AddAssociateBankAccountForm.propTypes = {
    values: PropTypes.object,
    form: PropTypes.object,
    onFormSubmit: PropTypes.func,
    associates: PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return (
            values &&
            values
                .toSeq()
                .toMap()
                .map(value => {
                    return Form.createFormField({
                        value
                    });
                })
                .set(
                    "ifsc_code",
                    Form.createFormField({
                        value: values.bank_branch
                    })
                )
                .toJS()
        );
    }
})(AddAssociateBankAccountForm);
